import httpClient from "@/api/httpClient";

const DASHBOARD = "/api/dashboard";

const getDashboardData = () => httpClient.get(DASHBOARD)

export {
    getDashboardData
}
